import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticateGuard } from './core/guards/authenticate.guard';
import { VerfiyPermGuard } from './core/guards/verfiy-perm.guard';
import { PagesComponent } from './pages/pages.component';
import { DBObjectModule } from './pages/settings/dbobject/dbobject.module';
import { PermRolModule } from './pages/settings/perm-rol/perm-rol.module';

// const routes: Routes = [];

// export const routes: Routes = [
const routes: Routes = [
  {
    path: '',
    component: PagesComponent, children: [
      { path: '', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
      { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthenticateGuard] },
      { path: 'dbobject', loadChildren: () => import('./pages/settings/dbobject/dbobject.module').then(m =>  m.DBObjectModule), canActivate: [AuthenticateGuard, VerfiyPermGuard] },
      { path: 'dbobject-modal', loadChildren: () => import('./pages/settings/dbobject/dbobjectmodal/dbobjectmodal.module').then(m => m.DbobjectmodalModule), canActivate: [AuthenticateGuard, VerfiyPermGuard]},
      { path: 'users', loadChildren: () => import('./pages/settings/users/users.module').then(m => m.UsersModule), canActivate: [AuthenticateGuard, VerfiyPermGuard] },
      { path: 'usersmodal', loadChildren: () => import('./pages/settings/users/insertupdate/insertupdate.module').then(m => m.InsertUpdateModule), canActivate: [AuthenticateGuard, VerfiyPermGuard]},
      { path: 'perm-rols', loadChildren: () => import('./pages/settings/perm-rol/perm-rol.module').then(m =>  PermRolModule), canActivate: [AuthenticateGuard, VerfiyPermGuard] },
    ]
  },
  // { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  // { path: '**', component: NotFoundComponent }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      useHash: true,
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
